import React, { createRef } from "react";
import { Progress, InfiniteScroll, Button, printComponent } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import CardView from "../../../../../../components/common/CardView";
import Search from "../../../../../../components/Search";
import Table from "../../../../../../components/Table";
import NavBar from "../../../../../../components/navigation";
import { AttendeesCertificate } from "../print-certificate/AttendeesCertificate";
import TrainingCertificatePresenter from "./TrainingCertificatePresenter";
import PrintTrainingCertificate from "../print-certificate/PrintTrainingCertificate";

class TrainingCertificatePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingCertificatePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      object: {},
      viewTraining: [],
      training: this.props.training,
      count: 0,
      limit: 10,
      current: 1,
    };
    this.contractPDF = createRef();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.training !== this.props.training) {
      await this.trainingData();
    }
  }

  async trainingData() {
    const { training } = this.props;
    const query = {
      where: {
        training: training,
      },
    };
    const viewTraining = await findObjectUseCase().execute(
      "certificate_training",
      query
    );
    this.setState({ viewTraining });
  }

  getCollectionName() {
    return "certificate_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  formatDate = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  printCertificate = (object) => {
    // const formattedDate = this.formatDate(new Date());
    // console.log("OBJECTTT PRINT", object);
    this.setState({ trainingObj: object });
    printComponent(this.contractPDF.current, "Tasks");

    // const iframe = document.createElement("iframe");
    // iframe.style.display = "none";
    // document.body.appendChild(iframe);

    // AttendeesCertificate(object, formattedDate, iframe);

    // setTimeout(() => {
    //   document.body.removeChild(iframe);
    // }, 1000);
  };

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, current, limit } = this.state;
    if (!schema) return <Progress />;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "training"
    );

    const generateCSV = () => {
      const { viewTraining } = this.state;
      let csvContent = "TRAINING, FIRST NAME, MIDDLE NAME, SURNAME\n"; // CSV header
      viewTraining.forEach((item) => {
        csvContent += `${item.training},${item.Firstname},${item.Middlename},${item.surname}\n`;
      });

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Certificate of Training Report-${new Date()}.csv`
      );
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
    return (
      <>
        <div className="d-none">
          <div ref={this.contractPDF} id="contractPDF">
            <PrintTrainingCertificate object={this.state.trainingObj} />
          </div>
        </div>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Learning and Development &gt;{" "}
              <span style={{ color: "#333" }}>Certificate of Training</span>
            </p>
          </div>
          <div className="overflow-auto">
            <InfiniteScroll
              className="h-100"
              loadMore={this.loadMore.bind(this)}
              // hasMore={!progress && count > objects.length}
            >
              <div className="">
                <CardView style={{ borderRadius: 0 }}>
                  <Search
                    schemas={this.getSchemas()}
                    onSubmit={this.searchSubmit.bind(this)}
                    fields={schema.fields}
                  />
                </CardView>

                <div
                  style={{
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <CardView style={{ borderRadius: 0 }}>
                    <div className="d-flex align-items-center">
                      <h4 className="text-primary">Certificate of Training</h4>
                      <div style={{ marginLeft: "auto" }}>
                        <Button onClick={() => generateCSV()}>
                          Download CSV
                        </Button>
                      </div>
                    </div>
                  </CardView>
                </div>

                <Table
                  progress={count > objects.length}
                  refetch={this.refetchData.bind(this)}
                  objectData={this.printCertificate.bind(this)}
                  fields={schema.fields}
                  objects={this.state.viewTraining}
                  collection={schema}
                  count={count}
                  limit={limit}
                  current={current}
                  loadPagination={this.onClickPagination.bind(this)}
                  actionsList={[
                    {
                      label: (
                        <i className="bi bi-printer"> Print Certificate</i>
                      ),
                      actionType: "object",
                    },
                  ]}
                  excludeFields={Object.keys(schema.fields).reduce(
                    (acc, key) => {
                      const options = schema.fields[key];
                      if (options.read === false) {
                        acc.push(key);
                      }
                      switch (options._type || options.type) {
                        case "Relation":
                        case "Array":
                        case "Object":
                        case "File":
                          acc.push(key);
                          break;
                        default:
                      }
                      return acc;
                    },
                    ["Id", "Created At", "Updated At", ...includeLabel]
                  )}
                  onClickItem={this.onClickItem.bind(this)}
                />
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </>
    );
  }
}

export default TrainingCertificatePage;
